// ------------------------------------
// CORES
// ------------------------------------
(function () {
  'use strict';
  if (previewMode) {
    // Variáveis
    const ref = 'styles';

    // Cor primária
    function changePrimaryColor() {
      const color = confTheme[ref]['primary-color'];
      $root[0].style.setProperty('--primary-color', color);
    }
    $root.on(confEvtDefault + ' lp-evt-primary-color', changePrimaryColor);

    // Cor secundária
    function changeSecondaryColor() {
      const color = confTheme[ref]['secondary-color'];
      $root[0].style.setProperty('--secondary-color', color);
    }
    $root.on(confEvtDefault + ' lp-evt-secondary-color', changeSecondaryColor);

    // Botão primário (Cor de fundo)
    function changeBtnPrimaryBgColor() {
      const color = confTheme[ref]['btn-primary-bg-color'];
      $root[0].style.setProperty('--btn-primary-bg-color', color);
    }
    $root.on(confEvtDefault + ' lp-evt-btn-primary-bg-color', changeBtnPrimaryBgColor);

    // Botão primário (Cor do texto)
    function changeBtnPrimaryTxtColor() {
      const color = confTheme[ref]['btn-primary-txt-color'];
      $root[0].style.setProperty('--btn-primary-txt-color', color);
    }
    $root.on(confEvtDefault + ' lp-evt-btn-primary-txt-color', changeBtnPrimaryTxtColor);

    // Botão secundário (Cor de fundo)
    function changeBtnSecondaryBgColor() {
      const color = confTheme[ref]['btn-secondary-bg-color'];
      $root[0].style.setProperty('--btn-secondary-bg-color', color);
    }
    $root.on(confEvtDefault + ' lp-evt-btn-secondary-bg-color', changeBtnSecondaryBgColor);

    // Botão secundário (Cor do texto)
    function changeBtnSecondaryTxtColor() {
      const color = confTheme[ref]['btn-secondary-txt-color'];
      $root[0].style.setProperty('--btn-secondary-txt-color', color);
    }
    $root.on(confEvtDefault + ' lp-evt-btn-secondary-txt-color', changeBtnSecondaryTxtColor);

    // Botão compra (Cor de fundo)
    function changeBtnBuyBgColor() {
      const color = confTheme[ref]['btn-buy-bg-color'];
      $root[0].style.setProperty('--btn-buy-bg-color', color);
    }
    $root.on(confEvtDefault + ' lp-evt-btn-buy-bg-color', changeBtnBuyBgColor);

    // Botão compra (Cor do texto)
    function changeBtnBuyTxtColor() {
      const color = confTheme[ref]['btn-buy-txt-color'];
      $root[0].style.setProperty('--btn-buy-txt-color', color);
    }
    $root.on(confEvtDefault + ' lp-evt-btn-buy-txt-color', changeBtnBuyTxtColor);

    // Cor dos títulos
    function changeFontTitleColor() {
      const color = confTheme[ref]['font-title-color'];
      $root[0].style.setProperty('--font-title-color', color);
    }
    $root.on(confEvtDefault + ' lp-evt-font-title-color', changeFontTitleColor);

    // Cor dos textos
    function changeFontTextColor() {
      const color = confTheme[ref]['font-text-color'];
      $root[0].style.setProperty('--font-text-color', color);
    }
    $root.on(confEvtDefault + ' lp-evt-font-text-color', changeFontTextColor);
  }
})();

// ------------------------------------
// FONTES
// ------------------------------------
(function () {
  'use strict';
  if (previewMode) {
    // Variáveis
    const ref = 'styles';

    // Fonte textos
    function changeFontDefaultFamily() {
      const font = confTheme[ref]['font-default-family'];
      $root[0].style.setProperty('--font-default-family', font);
    }
    $root.on(confEvtDefault + ' lp-evt-font-default-family', changeFontDefaultFamily);

    // Fonte título
    function changeFontTitleFamily() {
      const font = confTheme[ref]['font-title-family'];
      $root[0].style.setProperty('--font-title-family', font);
    }
    $root.on(confEvtDefault + ' lp-evt-font-title-slug', changeFontTitleFamily);

    // Fonte botão
    function changeFontBtnFamily() {
      const font = confTheme[ref]['font-button-family'];
      $root[0].style.setProperty('--font-button-family', font);
    }
    $root.on(confEvtDefault + ' lp-evt-font-button-family', changeFontBtnFamily);

    // Estilo fonte texto
    function changeFontDefaultWeight() {
      const font = confTheme[ref]['font-default-weight'];
      $root[0].style.setProperty('--font-default-weight', font);
    }
    $root.on(confEvtDefault + ' lp-evt-font-default-weight', changeFontDefaultWeight);

    // Estilo fonte título
    function changeFontTitleWeight() {
      const font = confTheme[ref]['font-title-weight'];
      $root[0].style.setProperty('--font-title-weight', font);
    }
    $root.on(confEvtDefault + ' lp-evt-font-title-weight', changeFontTitleWeight);

    // Estilo fonte botão
    function changeFontBtnWeight() {
      const font = confTheme[ref]['font-button-weight'];
      $root[0].style.setProperty('--font-button-weight', font);
    }
    $root.on(confEvtDefault + ' lp-evt-font-button-weight', changeFontBtnWeight);

    // Uppercase fonte título
    function changeFontTitleUppercase() {
      const value = confTheme[ref]['font-title-uppercase'];
      $root[0].style.setProperty('--font-title-uppercase', value);
    }
    $root.on(confEvtDefault + ' lp-evt-font-title-uppercase', changeFontTitleUppercase);

    // Uppercase fonte botão
    function changeFontBtnUppercase() {
      const value = confTheme[ref]['font-button-uppercase'];
      $root[0].style.setProperty('--font-button-uppercase', value);
    }
    $root.on(confEvtDefault + ' lp-evt-font-button-uppercase', changeFontBtnUppercase);

    // Estilo negrito
    function changeFontBold() {
      const font = confTheme[ref]['font-bold'];
      $root[0].style.setProperty('--font-bold', font);
    }
    $root.on(confEvtDefault + ' lp-evt-font-bold', changeFontBold);
  }
})();

// ------------------------------------
// BOTÕES
// ------------------------------------
const btnClassesRem = 'btn-primary btn-secondary btn-buy outline btn-pop btn-pulse';
(function () {
  'use strict';
  if (previewMode) {
    // Variáveis
    const ref = 'styles';
    const ref2 = 'general';

    // Formato dos botões
    function changeBtnRadius() {
      const value = confTheme[ref]['btn-radius'];
      $root[0].style.setProperty('--btn-radius', value);
    }
    $root.on(confEvtDefault + ' lp-evt-btn-radius', changeBtnRadius);

    // Formato dos campos
    function changeInputRadius() {
      const value = confTheme[ref]['input-radius'];
      $root[0].style.setProperty('--input-radius', value);
    }
    $root.on(confEvtDefault + ' lp-evt-input-radius', changeInputRadius);

    // Botão primário estilo
    function changeBtnPrimaryStyle() {
      const value = confTheme[ref2]['btn-primary-style'];
      const $elements = $('.btn-primary');
      $elements.removeClass('outline').addClass(value);
    }
    $root.on(confEvtDefault + ' lp-evt-btn-primary-style', changeBtnPrimaryStyle);

    // Botão primário animação
    function changeBtnPrimaryAni() {
      const value = confTheme[ref2]['btn-primary-animation'];
      const $elements = $('.btn-primary');
      $elements.removeClass('btn-pop btn-pulse').addClass(value);
    }
    $root.on(confEvtDefault + ' lp-evt-btn-primary-animation', changeBtnPrimaryAni);

    // Botão secundário estilo
    function changeBtnSecondaryStyle() {
      const value = confTheme[ref2]['btn-secondary-style'];
      const $elements = $('.btn-secondary');
      $elements.removeClass('outline').addClass(value);
    }
    $root.on(confEvtDefault + ' lp-evt-btn-secondary-style', changeBtnSecondaryStyle);

    // Botão secundário animação
    function changeBtnSecondaryAni() {
      const value = confTheme[ref2]['btn-secondary-animation'];
      const $elements = $('.btn-secondary');
      $elements.removeClass('btn-pop btn-pulse').addClass(value);
    }
    $root.on(confEvtDefault + ' lp-evt-btn-secondary-animation', changeBtnSecondaryAni);

    // Botão de compra estilo
    function changeBtnBuyStyle() {
      const value = confTheme[ref2]['btn-buy-style'];
      const $elements = $('.btn-buy');
      $elements.removeClass('outline').addClass(value);
    }
    $root.on(confEvtDefault + ' lp-evt-btn-buy-style', changeBtnBuyStyle);

    // Botão de compra animação
    function changeBtnBuyAni() {
      const value = confTheme[ref2]['btn-buy-animation'];
      const $elements = $('.btn-buy');
      $elements.removeClass('btn-pop btn-pulse').addClass(value);
    }
    $root.on(confEvtDefault + ' lp-evt-btn-buy-animation', changeBtnBuyAni);
  }
})();

// ------------------------------------
// BLOCOS PRODUTOS
// ------------------------------------
(function () {
  'use strict';
  if (previewMode) {
    // Variáveis
    const ref = 'products';
    const ref2 = 'styles';

    // Cor de fundo
    function changeBgColor() {
      const color = confTheme[ref][ref2]['prod-bl-bg-color'];
      $root[0].style.setProperty('--prod-bl-bg-color', color);
    }
    $root.on(confEvtDefault + ' lp-evt-prod-bl-bg-color', changeBgColor);

    // Cor do texto
    function changeTxtColor() {
      const color = confTheme[ref][ref2]['prod-bl-txt-color'];
      $root[0].style.setProperty('--prod-bl-txt-color', color);
    }
    $root.on(confEvtDefault + ' lp-evt-prod-bl-txt-color', changeTxtColor);

    // Cor do preço
    function changePriceColor() {
      const color = confTheme[ref][ref2]['prod-bl-price-color'];
      $root[0].style.setProperty('--prod-bl-price-color', color);
    }
    $root.on(confEvtDefault + ' lp-evt-prod-bl-price-color', changePriceColor);

    // Cor da flag
    function changeFlagColor() {
      const color = confTheme[ref][ref2]['prod-bl-flag-color'];
      $root[0].style.setProperty('--prod-bl-flag-color', color);
      setTimeout(() => {
        $root.trigger('lp-evt-populate-catalogos');
      }, 50);
    }
    $root.on(confEvtDefault + ' lp-evt-prod-bl-flag-color', changeFlagColor);

    // Arredondamento dos cantos
    function changeBorderRadius() {
      const value = confTheme[ref][ref2]['prod-bl-border-radius'];
      $root[0].style.setProperty('--prod-bl-border-radius', value);
    }
    $root.on(confEvtDefault + ' lp-evt-prod-bl-border-radius', changeBorderRadius);

    // Exibe/Oculta avaliações
    function toggleRating() {
      const value = confTheme[ref]['prod-bl-rating-show'];
      value == '1'
        ? $('.prod-bl-wrp .prod-bl-stars').removeClass('d-none')
        : $('.prod-bl-wrp .prod-bl-stars').addClass('d-none');
      $root.trigger('lp-evt-populate-catalogos');
    }
    $root.on(confEvtDefault + ' lp-evt-prod-bl-rating-show', toggleRating);

    // Exibe/Oculta botão
    function toggleBtn() {
      const value = confTheme[ref]['prod-bl-btn-show'];
      value == '1'
        ? $('.prod-bl-wrp .prod-bl-btns').removeClass('d-none')
        : $('.prod-bl-wrp .prod-bl-btns').addClass('d-none');
      value == '1' ? $('.prod-bl-wrp').addClass('prod-bl-with-btn') : $('.prod-bl-wrp').removeClass('prod-bl-with-btn');
      $root.trigger('lp-evt-populate-catalogos');
    }
    $root.on(confEvtDefault + ' lp-evt-prod-bl-btn-show', toggleBtn);

    // Ativa/Desativa imagem hover
    function toggleImgHover() {
      $root.trigger('lp-evt-populate-catalogos');
    }
    $root.on(confEvtDefault + ' lp-evt-prod-bl-img-hover', toggleImgHover);

    // Altera o estilo do bloco
    function changeProdStyle() {
      const value = confTheme[ref]['prod-bl-style'];
      $('.prod-bl-wrp').removeClass('prod-bl-stl-1 prod-bl-stl-2 prod-bl-stl-3').addClass(value);
    }
    $root.on(confEvtDefault + ' lp-evt-prod-bl-style', changeProdStyle);

    // Altera o formato do imagem
    function changeProdImgFmt() {
      const value = confTheme[ref]['prod-bl-img-format'];
      $('.prod-bl-img')
        .removeClass('prod-bl-img-default prod-bl-img-tall prod-bl-img-land')
        .addClass('prod-bl-img-' + value);
      $root.trigger('lp-evt-populate-catalogos');
    }
    $root.on(confEvtDefault + ' lp-evt-prod-bl-img-format', changeProdImgFmt);

    // Altera o alinhamento das informações
    function changeInfosAlign() {
      const value = confTheme[ref]['prod-bl-infos-align'];
      $('.prod-bl-wrp .prod-bl-infos').removeClass('left center').addClass(value);
    }
    $root.on(confEvtDefault + ' lp-evt-prod-bl-infos-align', changeInfosAlign);

    // Altera o texto dos botões
    function changeBtnTxt() {
      const value = confTheme[ref]['prod-bl-btn-txt'];
      $('.prod-bl-wrp .prod-bl-btns .btn').text(value);
    }
    $root.on(confEvtDefault + ' lp-evt-prod-bl-btn-txt', changeBtnTxt);

    // Altera o tipo dos botões
    function changeBtnClass() {
      const value = confTheme[ref]['prod-bl-btn-class'];
      $('.prod-bl-wrp .prod-bl-btns .btn')
        .removeClass('btn-primary btn-secondary btn-buy btn-white outline')
        .addClass(value + ' ' + confTheme['general'][value + '-style']);
    }
    $root.on(confEvtDefault + ' lp-evt-prod-bl-btn-class', changeBtnClass);

    // Exibe/Oculta parcelamento
    function changeParcShow() {
      const value = confTheme[ref]['prod-bl-parc-show'];
      value == '1'
        ? $('.prod-bl-wrp .prod-bl-parc').removeClass('d-none')
        : $('.prod-bl-wrp .prod-bl-parc').addClass('d-none');
      $root.trigger('lp-evt-populate-catalogos');
    }
    $root.on(confEvtDefault + ' lp-evt-prod-bl-parc-show', changeParcShow);

    // Altera o texto do parcelamento
    function changeParcTxt() {
      $root.trigger('lp-evt-populate-catalogos');
    }
    $root.on(confEvtDefault + ' lp-evt-prod-bl-parc-txt', changeParcTxt);

    // Exibe/Oculta ícone cartão
    function changeParcIcon() {
      $root.trigger('lp-evt-populate-catalogos');
    }
    $root.on(confEvtDefault + ' lp-evt-prod-bl-parc-icon', changeParcIcon);

    // Exibe/Oculta desconto pix
    function changePixShow() {
      const value = confTheme[ref]['prod-bl-pix-show'];
      value == '1'
        ? $('.prod-bl-wrp .prod-bl-pix').removeClass('d-none')
        : $('.prod-bl-wrp .prod-bl-pix').addClass('d-none');
      $root.trigger('lp-evt-populate-catalogos');
    }
    $root.on(confEvtDefault + ' lp-evt-prod-bl-pix-show', changePixShow);

    // Altera o texto do desconto pix
    function changePixTxt() {
      $root.trigger('lp-evt-populate-catalogos');
    }
    $root.on(confEvtDefault + ' lp-evt-prod-bl-pix-txt', changePixTxt);

    // Exibe/Oculta ícone pix
    function changePixIcon() {
      $root.trigger('lp-evt-populate-catalogos');
    }
    $root.on(confEvtDefault + ' lp-evt-prod-bl-pix-icon', changePixIcon);

    // Exibe/Oculta aviso estoque
    function changeOutstockShow() {
      $root.trigger('lp-evt-populate-catalogos');
    }
    $root.on(confEvtDefault + ' lp-evt-out-of-stock-show', changeOutstockShow);

    // Altera o texto do aviso estoque
    function changeOutstockTxt() {
      const value = confTheme[ref]['out-of-stock-txt'];
      $('.prod-bl-wrp .prod-bl-out-of-stock').text(value);
    }
    $root.on(confEvtDefault + ' lp-evt-out-of-stock-txt', changeOutstockTxt);

    // Altera cor de fundo do aviso estoque
    function changeOutstockBg() {
      const color = confTheme[ref][ref2]['out-of-stock-bg'];
      $root[0].style.setProperty('--out-of-stock-bg', color);
    }
    $root.on(confEvtDefault + ' lp-evt-out-of-stock-bg', changeOutstockBg);

    // Altera cor do texto do aviso estoque
    function changeOutstockColor() {
      const color = confTheme[ref][ref2]['out-of-stock-color'];
      $root[0].style.setProperty('--out-of-stock-color', color);
    }
    $root.on(confEvtDefault + ' lp-evt-out-of-stock-color', changeOutstockColor);

    // Altera grid (Desktop)
    function changeGridDesktop() {
      $root.trigger('lp-evt-populate-catalogos');
    }
    $root.on(confEvtDefault + ' lp-evt-prod-bl-cols-desktop', changeGridDesktop);

    // Altera grid (Tablet)
    function changeGridTablet() {
      $root.trigger('lp-evt-populate-catalogos');
    }
    $root.on(confEvtDefault + ' lp-evt-prod-bl-cols-tablet', changeGridTablet);

    // Altera grid (Mobile)
    function changeGridMobile() {
      $root.trigger('lp-evt-populate-catalogos');
    }
    $root.on(confEvtDefault + ' lp-evt-prod-bl-cols-mobile', changeGridMobile);

    // Carrinho Ajax
    function changeCartAjax() {
      $root.trigger('lp-evt-populate-catalogos');
    }
    $root.on(confEvtDefault + ' lp-evt-prod-bl-cart-ajax', changeCartAjax);

    // Carrinho Ajax (Texto do botão)
    function changeCartAjaxBtnTxt() {
      const value = confTheme[ref]['prod-bl-cart-ajax-btn-txt'];
      if ($('.cart-ajax-btn-txt').length) {
        $('.cart-ajax-btn-txt').text(value);
      }
    }
    $root.on(confEvtDefault + ' lp-evt-prod-bl-cart-ajax-btn-txt', changeCartAjaxBtnTxt);

    // Carrinho Ajax (Estilo do botão)
    function changeCartAjaxBtnStyle() {
      const value = confTheme[ref]['prod-bl-cart-ajax-btn-class'];
      if ($('.cart-ajax-btn').length) {
        $('.cart-ajax-btn').removeClass('btn-primary btn-secondary btn-buy btn-white btn-grey').addClass(value);
      }
    }
    $root.on(confEvtDefault + ' lp-evt-prod-bl-cart-ajax-btn-class', changeCartAjaxBtnStyle);

    // Carrinho Ajax (Manter estilo)
    function changeCartAjaxKeep() {
      const value = confTheme[ref]['prod-bl-cart-ajax-keep-mb'];
      if ($('.cart-ajax-btn-wrp').length) {
        value == 1 ? $('.cart-ajax-btn-wrp').removeClass('btn-fade') : $('.cart-ajax-btn-wrp').addClass('btn-fade');
      }
    }
    $root.on(confEvtDefault + ' lp-evt-prod-bl-cart-ajax-keep-mb', changeCartAjaxKeep);
  }
})();

// ------------------------------------
// INFORMAÇÕES
// ------------------------------------
(function () {
  'use strict';
  if (previewMode) {
    // Variáveis
    const ref = 'general';
    const refEvtPrefix = 'lp-evt-infos-';

    // Altera o e-amil
    function changeMail() {
      const value = confTheme[ref]['email'];
      const $el = $('[data-e-mail]');
      if (value != '') {
        $el.closest('a').show();
        $el.text(value);
      } else {
        $el.closest('a').hide();
      }
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'email', changeMail);

    // Altera o telefone
    function changePhone() {
      const value = confTheme[ref]['telefone'];
      const $el = $('[data-e-phone]');
      if (value != '') {
        $el.closest('a').show();
        $el.text(value);
      } else {
        $el.closest('a').hide();
      }
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'telefone', changePhone);

    // Altera o endereço
    function changeAddress() {
      const value = confTheme[ref]['endereco'];
      const $el = $('[data-e-address]');
      if (value != '') {
        $el.closest('li').show();
        $el.html(mdParse(value, true));
      } else {
        $el.closest('li').hide();
      }
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'endereco', changeAddress);

    // Altera o horário de atendimento
    function changeHorario() {
      const value = confTheme[ref]['horario-atendimento'];
      const $el = $('[data-e-horario]');
      if (value != '') {
        $el.closest('li').show();
        $el.html(mdParse(value, true));
      } else {
        $el.closest('li').hide();
      }
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'horario-atendimento', changeHorario);

    // Altera o whatsapp
    function changeWhats() {
      const value = confTheme[ref]['whatsapp'];
      const $el = $('[data-e-whats]');
      if (value != '') {
        $el.closest('a').show();
        $el.text(value);
      } else {
        $el.closest('a').hide();
      }
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'whatsapp', changeWhats);

    // Oculta/Exibe whatsapp lateral
    function changeWhatsLat() {
      const value = confTheme[ref]['whatsapp-lateral'];
      const $whatsLat = $('.contatos-lateral');
      value == '1' ? $whatsLat.removeClass('d-none') : $whatsLat.addClass('d-none');
      handleWhatsLatPos();
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'whatsapp-lateral', changeWhatsLat);

    // Posição do whatsapp lateral
    function changeWhatsLatPos() {
      const value = confTheme[ref]['whatsapp-lateral-pos'];
      const $whatsLat = $('.contatos-lateral');
      $whatsLat.removeClass('middle-right middle-left bottom-right bottom-left').addClass(value);
      handleWhatsLatPos();
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'whatsapp-lateral-pos', changeWhatsLatPos);
  }
})();

// ------------------------------------
// REDES SOCIAIS (LISTA)
// ------------------------------------
(function () {
  'use strict';
  if (previewMode) {
    // Variáveis
    const ref = 'general';
    const refEvtPrefix = 'lp-evt-infos-';

    // Elementos
    const $list = $('.social-icons');

    // Altera a lista
    function changeList() {
      const lista = confTheme[ref]['redes-sociais'];
      $list.html('');
      if ($list.length > 0) {
        for (let i = 0; i < lista.length; i++) {
          if (lista[i].url != '' && lista[i].status == '1') {
            const item = `
            <a href="${lista[i].url}" rel="nofollow" target="_blank" class="social-icon si-circle" title="${
              lista[i].titulo
            }">${getSvgIcon(lista[i].slug)}</a>`;
            $list.append(item);
          }
        }
      }
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'redes-sociais-lista', changeList);
  }
})();

// ------------------------------------
// CARRINHO
// ------------------------------------
(function () {
  'use strict';
  if (previewMode) {
    // Variáveis
    const ref = 'general';
    const refEvtPrefix = 'lp-evt-cart-';

    // Altera o estilo do carrinho
    function changeCartStyle() {
      const value = confTheme[ref]['cart-style'] || 'page';
      if (value === 'side') {
        $('.header-cart-btn').removeClass('dropdown-toggle');
        $('.header-cart-btn-wrp').removeClass('open');
        $('.header-cart-btn').attr('data-side-toggle', 'cart-side');
        sideOpen('cart-side');
      } else {
        $('.header-cart-btn').removeAttr('data-side-toggle');
        sideClose('cart-side');
        $('.header-cart-btn').addClass('dropdown-toggle');
        $('.header-cart-btn-wrp').addClass('open');
      }
    }
    $root.on(refEvtPrefix + 'style', changeCartStyle);

    // Altera o título
    function changeCartTit() {
      const value = confTheme[ref]['cart-title'];
      const $el = $('.card-side-title');
      $el.text(value);
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'title', changeCartTit);

    // Altera a classe do botão de finalizar compra
    function changeCartBtnClass() {
      const value = confTheme[ref]['cart-btn-class'] || 'btn-primary';
      const $el = $('.cart-btn-cta');
      $el
        .removeClass('btn-primary btn-secondary btn-buy btn-white outline')
        .addClass(value + ' ' + confTheme['general'][value + '-style']);
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'btn-class', changeCartBtnClass);

    // Altera o texto do botão de finalizar compra
    function changeCartBtnTxt() {
      const value = confTheme[ref]['cart-btn-txt'];
      const $el = $('.cart-btn-cta');
      $el.text(value);
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'btn-txt', changeCartBtnTxt);

    // Altera o título do carrinho vazio
    function changeCartEmptyTit() {
      const value = confTheme[ref]['cart-empty-tit'];
      const $el = $('.cart-side-empty-tit, .dropdown-cart-empty-tit');
      $el.text(value);
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'empty-tit', changeCartEmptyTit);

    // Altera o texto do carrinho vazio
    function changeCartEmptyTxt() {
      const value = confTheme[ref]['cart-empty-txt'];
      const $el = $('.cart-side-empty-txt, .dropdown-cart-empty-txt');
      $el.text(value);
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'empty-txt', changeCartEmptyTxt);

    // Altera o texto do botão do carrinho vazio
    function changeCartEmptyBtnTxt() {
      const value = confTheme[ref]['cart-empty-btn-txt'];
      const $el = $('.cart-side-empty-btn .btn, .dropdown-cart-empty-btn .btn');
      $el.text(value);
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'empty-btn-txt', changeCartEmptyBtnTxt);
  }
})();

// ------------------------------------
// CÓDIGOS
// ------------------------------------
(function () {
  'use strict';
  if (previewMode) {
    // Variáveis
    const ref = 'codes';
    const refEvtPrefix = 'lp-evt-';

    // Altera o css customizado
    function changeCssCustom() {
      const code = confTheme[ref]['custom-css'];
      $('#custom-css style').text(code);
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'custom-css', changeCssCustom);
  }
})();
